const EmployerCodeActionTypes = {
  SET_EMPLOYER_CODE: 'SET_EMPLOYER_CODE',
  INITIALIZE_EMPLOYERCODE_STATE: 'INITIALIZE_EMPLOYERCODE_STATE',
};

export default EmployerCodeActionTypes;
